import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon = styled(FontAwesomeIcon)({
    fontSize: 26,
    color: '#656566',
    margin: '0 10px',
    marginTop: '30px',
});

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;

    .inputs {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .input {
        display: flex;
        align-items: center;

        .removed-font {
            width: 250px;
        }
    }
`

export const Header = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    margin: 12px auto;
    font-size: 20px;
    font-weight: 600;
    width: 100%;
`;

export const Text = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 20px;
`;

export const TitleText = styled.p`
    font-size: 13px;
    line-height: 24px;
    font-weight: 400;
    padding-bottom: 8px;
`;

export const ButtonWrapper = styled.div`
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
`;
